module.exports = __webpack_public_path__ + "04_short_gold.8481c3cd.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/dad/layer5/04_short_gold.png
// module id = AyY5
// module chunks = 0